import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, LoadingButton } from '@redpanda/ui';

interface MultiBulkActionButtonProps {
  selectedCount: number;
  onDelete: () => void;
  onArchive?: () => void;
  onRestore?: () => void;
  isDeleting?: boolean;
  isArchiving?: boolean;
  isRestoring?: boolean;
  showArchive?: boolean;
  showRestore?: boolean;
}

const MultiBulkActionButton: React.FC<MultiBulkActionButtonProps> = ({
  selectedCount,
  onDelete,
  onArchive,
  onRestore,
  isDeleting = false,
  isArchiving = false,
  isRestoring = false,
  showArchive = true,
  showRestore = false
}) => {
  const { t } = useTranslation();

  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="flex items-center space-x-3">
      <span className="text-sm text-gray-700 dark:text-white font-medium">
        {t('common.bulk.selectedCount', { count: selectedCount })}
      </span>

      <div className="flex space-x-2">
        <LoadingButton
          onClick={onDelete}
          loading={isDeleting}
          className="bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-white font-bold py-2 px-4 rounded"
        >
          {t('common.bulk.deleteAction')} ({selectedCount})
        </LoadingButton>

        {showArchive && onArchive && (
          <LoadingButton
            onClick={onArchive}
            loading={isArchiving}
            className="bg-orange-600 hover:bg-orange-700 disabled:bg-orange-400 text-white font-bold py-2 px-4 rounded"
          >
            {t('common.bulk.archiveAction')} ({selectedCount})
          </LoadingButton>
        )}

        {showRestore && onRestore && (
          <LoadingButton
            onClick={onRestore}
            loading={isRestoring}
            className="bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white font-bold py-2 px-4 rounded"
          >
            {t('common.bulk.restoreAction')} ({selectedCount})
          </LoadingButton>
        )}
      </div>
    </div>
  );
};

export default MultiBulkActionButton;